import { EqualizerIcon } from "@/shared/assets/svg/icons";
import { IntegrationStatus, IntegrationStatusTypes } from "../../model/types/integration-card";
import "./status-badge.scss";

interface StatusBadgeProps {
  status: IntegrationStatus;
}

export const StatusBadge = ({ status }: StatusBadgeProps) => {
  if (status === IntegrationStatusTypes.CONNECTED) {
    return (
      <div className="status-badge status-badge--connected">
        <EqualizerIcon />
        <span>Интеграция подключена</span>
      </div>
    );
  }

  if (status === IntegrationStatusTypes.DISCONNECTED) {
    return (
      <div className="status-badge status-badge--disconnected">
        <EqualizerIcon />
        <span>Интеграция отключена</span>
      </div>
    );
  }

  return null;
};

